import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { QR } from '@src/queryKeys';
import usersApi from '@src/apis/usersApi';
import useAccessToken from '@hooks/useAccessToken';

const useGetMyUniqueCode = (): UseQueryResult<string, unknown> => {
  const [accessToken] = useAccessToken();

  return useQuery({
    queryKey: [QR],
    enabled: !!accessToken,
    queryFn: async () => {
      const res = await usersApi.getMyUniqueCode();
      return res.data.userUniqueCode;
    },
    // suspense 옵션은 react-query v5 에서 제거되어 동작하지 않던 잔재라 걷어냈다.
    // 소비처(QRComponent)는 data 유무로 자체 분기한다.
  });
};

export default {
  useGetMyUniqueCode,
};
